import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";

import {setLookActiveCategory, setLookOpened, setLookPageOpened} from "../../../../../actions/lookFunctions";
import {getLookList} from "../../../lookNavigation/lookFunctions";
import {getCurrentLayout} from "../../../../appLayout";
import {getDesignRecommendedNavItems} from "../../../lookNavigation/lookNavigationFunctions";
import {getFeatureGroupName} from "../../../../../misc/helpers";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import WithZoomToFeature from "../../../hocs/withZoomToFeature";
import LookCanvasContext from "../../../lookCanvasContext";
import GroheCartDesignRecommendedList from "./groheCartDesignRecommendedList";


const GroheCartDesignRecommended = (props) => {

  const {intl, fabricatorData, setLookPageOpened, setLookActiveCategory} = props;

  const parentGroups = getLookList();
  if (!parentGroups) {
    return null
  }
  const layout = getCurrentLayout();

  const parentGroupClick = (featureGroup, zoomToFeatureGroup) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartCheckoutSuccessViewAll + featureGroup.partId);
    setLookPageOpened("");
    zoomToFeatureGroup(featureGroup.partId, featureGroup.activeFeature);
    setTimeout(() => {
      setLookActiveCategory(featureGroup.partId);
    }, 300)
  }

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => (
            <div className="gc-content">
              {parentGroups.map((parentGroup) => {
                const {featureGroup} = parentGroup;
                const navItems = layout.designNavigationItems({part: featureGroup});
                if (!navItems.length) {
                  return null
                }
                const designRecommended = getDesignRecommendedNavItems(navItems);
                // if (!designRecommended.length) {
                //   return null
                // }
                const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
                return (
                  <section className="gc-recommended" key={parentGroup.partId}>
                    <header className="gc-recommended__header">
                      <div className="gc-recommended__header-left">
                        <h1 className="gc-header__title">
                          <FormattedMessage id="grohe.cart.success.recommended.title" values={{featureGroupName}}/>
                        </h1>
                        <h2 className="gc-header__sub-title">
                          <FormattedMessage id="grohe.cart.success.recommended.subTitle" values={{featureGroupName}}/>
                        </h2>
                      </div>
                      <div className="gc-recommended__header-right">
                        <Button className="look-button look-button--secondary look-button--big look-button--large nowrap"
                                onClick={() => parentGroupClick(featureGroup, zoomToFeatureGroup)}>
                          <FormattedMessage id="grohe.cart.success.recommended.button"/>
                        </Button>
                      </div>
                    </header>
                    <GroheCartDesignRecommendedList featuresList={designRecommended.length ? designRecommended : navItems.slice(0, 10)}
                                                    zoomToFeatureGroup={zoomToFeatureGroup}/>
                  </section>
                )
              })}
            </div>
          )}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  // const {filterGroups} = store.filterState;
  // const {activePreset} = store.bathroomVisualizerState;
  const fabricatorData = store.fabricatorState;
  return {
    // filterGroups,
    // activePreset,
    fabricatorData
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOpened,
  setLookActiveCategory,
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartDesignRecommended))
)
